import { __rest } from "tslib";
import { swalAlertError } from '@/core/helpers/sweet-alert';
import { defineComponent, ref } from 'vue';
import { useDropzone } from 'vue3-dropzone';
export default defineComponent({
    name: 'InputDropzoneFile',
    emits: ['change'],
    props: {
        options: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    setup(props, { emit }) {
        const file = ref([]);
        const onDrop = (acceptFiles, rejectReasons) => {
            if (rejectReasons.length) {
                swalAlertError(rejectReasons[0].errors[0].message, 'Got it!', false);
            }
            file.value = acceptFiles;
            emit('change', file.value);
        };
        const onFileDialogCancel = () => {
            file.value = [];
            emit('change', file.value);
        };
        const _a = useDropzone(Object.assign({ onDrop,
            onFileDialogCancel }, props.options)), { getRootProps, getInputProps } = _a, rest = __rest(_a, ["getRootProps", "getInputProps"]);
        return Object.assign({ file,
            getRootProps,
            getInputProps }, rest);
    }
});
